module.exports = __webpack_public_path__ + "img/admission.efe90019.jpeg";